import {
  Box,
  Button,
  ButtonAppearance,
  ButtonSize,
  FormControl,
  Icon,
  IconSize,
  Select,
  Text,
  TextFieldAppearance,
  TextFieldSize,
} from '@bechtel/gds';
import { SortOrder } from '@bechtel/types';
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { FieldProps } from 'formik';
import { find } from 'lodash';
import { FC } from 'react';
import { sortByList } from '../form-state';

const SortSelectedItem = ({ item }: any) => {
  const { i18n } = useLingui();
  return (
    <Text size="400" color="grey.1000" family="graphik">
      {i18n._(item.label)}
    </Text>
  );
};

const SortListItem = ({ item }: any) => {
  const { i18n } = useLingui();
  return (
    <Text size="400" color="grey.1000">
      {i18n._(item.label)}
    </Text>
  );
};

export const SortByList: FC<FieldProps> = ({ form }) => {
  const isAsc = form.values.sortDir === SortOrder.ASC;
  return (
    <Box px={{ sm: '400' }} py={{ sm: '500' }} data-testid="sort-by-container">
      <Box mr={{ sm: '400' }} flexGrow={{ sm: 1 }}>
        <FormControl
          style={{ flexGrow: 1 }}
          label={t`Sort By`}
          css={`
            font-family: ${({ theme }) => theme.fontFamilies.graphik};
          `}
        >
          <Select
            data-testid="sort-by"
            size={TextFieldSize.LARGE}
            appearance={TextFieldAppearance.NORMAL}
            selectedItem={find(sortByList, { value: form.values.sortBy })}
            items={sortByList}
            itemComponent={SortListItem}
            selectedComponent={SortSelectedItem}
            onSelectedItemChange={(changes: any) => {
              form.setFieldValue('sortBy', changes.selectedItem.value);
            }}
          />
        </FormControl>
      </Box>
      <Box>
        <Button
          data-testid="sort-dir"
          appearance={ButtonAppearance.SECONDARY}
          size={ButtonSize.LARGE}
          css={`
            padding-left: ${({ theme }) => theme.spacings[450]};
            padding-right: ${({ theme }) => theme.spacings[450]};
          `}
          onClick={() => {
            const newValue = isAsc ? SortOrder.DESC : SortOrder.ASC;
            form.setFieldValue('sortDir', newValue);
          }}
        >
          <Icon
            fillColor="bechtel.blue.800"
            icon={isAsc ? 'sort-amount-down' : 'sort-amount-up'}
            size={IconSize.MEDIUM}
          />
        </Button>
      </Box>
    </Box>
  );
};
